import { Box, Button, CircularProgress } from '@mui/material';

interface LoadMoreButtonProps {
  hasMore: boolean;
  isLoading: boolean;
  onClick: () => void;
}

export function LoadMoreButton({
  hasMore,
  isLoading,
  onClick,
}: LoadMoreButtonProps): JSX.Element | null {
  if (!hasMore) return null;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 1.5 }}>
      <Button
        size="small"
        variant="outlined"
        onClick={onClick}
        disabled={isLoading}
        startIcon={isLoading ? <CircularProgress size={14} /> : null}
      >
        {isLoading ? 'Cargando...' : 'Cargar más'}
      </Button>
    </Box>
  );
}
